import './Header.css'
import {useEffect, useState} from "react";
import {useMediaQuery} from "react-responsive";
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {Link, useNavigate} from "react-router-dom";

const Header = ({isConnected}) => {
    const title = 'Agri-Tech Solution Madagascar';
    const isDesktop = useMediaQuery({ minWidth: 992 });
    const [showMenu, setShowMenu] = useState(true);
    const navigate = useNavigate();

    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };

    const disconnect = () => {
        sessionStorage.removeItem('auth');
        window.location.reload();
    }

    useEffect(() => {
        setShowMenu(isDesktop);
    }, [isDesktop]);

    return (
        <header className="header">
            <div className="header-container">
                <div className="logo">
                    <div>
                        <img src="logo480.png" alt={title} className="logo-img" />
                    </div>
                    <button onClick={toggleMenu} className="menu-button">
                        {showMenu? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faBars} />}
                    </button>
                </div>

                <nav className={showMenu ? "nav-visible" : "nav-hidden"}>
                    <ul className="nav-links h-show ">
                        <li><a href="#about">A propos</a></li>
                        <li><a href="#service">Nos services</a></li>
                        <li><a href="#offers">Nos offres</a></li>
                        <li><a href="#team">Notre équipe</a></li>
                        <li><a href="#gallery">Photos</a></li>
                        <li><a href="#feedback">Contactez-nous</a></li>
                        <li>
                            {
                                isConnected?
                                    <button className={"connected-button deconnected-button"}
                                        onClick={disconnect}
                                    >
                                        Se déconnecter
                                    </button>
                                    :
                                    <Link to={"/login"} className={"header-link"}>
                                        <button className={"connected-button"}>
                                            Se connecter
                                        </button>
                                    </Link>
                            }
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    )
}
export default Header;
